(function () {
  'use strict';

  var PRICE_SELECTORS = [
    '.pp-price-value',
    '[id^="ProductPrice-"]',
    '.product-price__price',
    '.product-price .price',
    '.product-price__sale',
    '.special-price',
    '.old-price',
    '.price-new',
    '.price-old',
    '.category-products-figma__price',
    '.category-products-figma__price-row .price',
    '.ai-catalog-product-price',
    'span.money',
    '.totals__subtotal-value',
    '.grid-view-item .price',
    '.product-item .price',
    '.quick-view .price',
    '.quick-view .compare-price',
    '.minicart-header .product-price .price',
    '.popup-mycart .money',
    '.pu-cart .price-new',
    '.previewCartCheckout-price'
  ].join(',');

  var SKIP_ANCESTORS = [
    '.header-currency-switcher',
    '.localization-form',
    '.disclosure__list',
    'select',
    'option',
    'script',
    'style',
    'noscript',
    '.visually-hidden'
  ].join(',');

  var PRICE_RE = /^\$\s?[\d,]+(?:\.\d{1,2})?$/;
  var observer;
  var scheduled;

  function getActiveCurrencyCode() {
    var code = String(window.presentment_currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '').toUpperCase();
    return code === 'CAD' || code === 'USD' ? code : null;
  }

  function shouldSkip(el) {
    if (!el || el.nodeType !== 1) return true;
    if (el.closest('[data-pp-currency-skip]') || el.closest('[data-pp-cad-skip]')) return true;
    if (el.closest(SKIP_ANCESTORS)) return true;
    return false;
  }

  function isLeafPriceCandidate(el, all) {
    for (var i = 0; i < all.length; i += 1) {
      var other = all[i];
      if (other !== el && el.contains(other)) return false;
    }
    return true;
  }

  function normalizePriceText(text) {
    return String(text || '').replace(/\u00a0/g, ' ').trim().replace(/\s+(CAD|USD)\s*$/i, '').trim();
  }

  function labelElement(el, code) {
    if (shouldSkip(el)) return;
    if (el.querySelector('.pp-currency-code')) return;

    var base = normalizePriceText(el.textContent);
    if (!PRICE_RE.test(base)) return;

    el.innerHTML = base + ' <span class="pp-currency-code">' + code + '</span>';
  }

  function collectCandidates(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = Array.prototype.slice.call(scope.querySelectorAll(PRICE_SELECTORS));
    return nodes.filter(function (el) {
      return !shouldSkip(el) && isLeafPriceCandidate(el, nodes);
    });
  }

  function appendCurrencyLabels(root) {
    var code = getActiveCurrencyCode();
    if (!code) return;

    collectCandidates(root).forEach(function (el) {
      labelElement(el, code);
    });
  }

  function scheduleAppend(root) {
    if (scheduled) window.clearTimeout(scheduled);
    scheduled = window.setTimeout(function () {
      scheduled = null;
      appendCurrencyLabels(root || document);
    }, 60);
  }

  function bindObserver() {
    if (observer || !window.MutationObserver) return;

    observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var mutation = mutations[i];
        if (mutation.type === 'characterData') {
          scheduleAppend(document);
          return;
        }
        if (mutation.addedNodes && mutation.addedNodes.length) {
          scheduleAppend(document);
          return;
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function init() {
    if (!getActiveCurrencyCode()) return;
    appendCurrencyLabels(document);
    bindObserver();

    if (window.jQuery) {
      window.jQuery(document).ajaxComplete(function () {
        scheduleAppend(document);
      });
    }

    document.addEventListener('shopify:section:load', function () {
      scheduleAppend(document);
    });
  }

  window.ppAppendCurrencyLabels = appendCurrencyLabels;
  window.ppAppendCadLabels = appendCurrencyLabels;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
